import React, { useState } from 'react';
import { CATEGORIES } from '../constants/categories';
import { ChevronDown, ChevronRight, Filter } from 'lucide-react';

const CategorySidebar = ({ selectedCategory, selectedSubcategory, onSelect }) => {
  const [expanded, setExpanded] = useState({ bacanie: true });

  const toggleExpand = (categoryId) => {
    setExpanded((prev) => ({ ...prev, [categoryId]: !prev[categoryId] }));
  };

  return (
    <aside className="bg-white border border-slate-200 rounded-lg shadow-sm p-4 sticky top-4">
      <div className="flex items-center space-x-2 mb-4 pb-3 border-b border-slate-200">
        <Filter className="w-5 h-5 text-blue-900" />
        <h3 className="font-bold text-slate-900" style={{ fontFamily: 'Outfit' }}>
          Categorii
        </h3>
      </div>

      <div className="space-y-1">
        <button
          onClick={() => onSelect(null, null)}
          className={`w-full text-left px-3 py-2 rounded-md transition-colors ${
            !selectedCategory
              ? 'bg-blue-900 text-white font-semibold'
              : 'text-slate-700 hover:bg-blue-50'
          }`}
          style={{ fontFamily: 'IBM Plex Sans' }}
          data-testid="category-all"
        >
          Toate produsele
        </button>

        {CATEGORIES.map((category) => {
          const isSelected = selectedCategory === category.id;
          const hasSubcategories = category.subcategories.length > 0;
          const isExpanded = expanded[category.id];

          return (
            <div key={category.id}>
              <div
                className={`flex items-center rounded-md transition-colors ${
                  isSelected && !selectedSubcategory
                    ? 'bg-blue-900 text-white font-semibold'
                    : 'text-slate-700 hover:bg-blue-50'
                }`}
              >
                <button
                  onClick={() => onSelect(category.id, null)}
                  className="flex-1 text-left px-3 py-2 rounded-md"
                  style={{ fontFamily: 'IBM Plex Sans' }}
                  data-testid={`category-${category.id}`}
                >
                  {category.name}
                </button>
                {hasSubcategories && (
                  <button
                    onClick={() => toggleExpand(category.id)}
                    className="px-2 py-2"
                    data-testid={`expand-${category.id}`}
                  >
                    {isExpanded ? (
                      <ChevronDown className="w-4 h-4" />
                    ) : (
                      <ChevronRight className="w-4 h-4" />
                    )}
                  </button>
                )}
              </div>

              {hasSubcategories && isExpanded && (
                <div className="ml-4 mt-1 space-y-1 border-l-2 border-blue-100 pl-3">
                  {category.subcategories.map((sub) => (
                    <button
                      key={sub}
                      onClick={() => onSelect(category.id, sub)}
                      className={`w-full text-left px-3 py-1.5 rounded-md text-sm transition-colors ${
                        selectedCategory === category.id && selectedSubcategory === sub
                          ? 'bg-orange-100 text-orange-800 font-semibold'
                          : 'text-slate-600 hover:bg-slate-50'
                      }`}
                      style={{ fontFamily: 'IBM Plex Sans' }}
                      data-testid={`subcategory-${sub.toLowerCase()}`}
                    >
                      {sub}
                    </button>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </aside>
  );
};

export default CategorySidebar;
